export default "__VITE_ASSET__674762e8__"